import React from 'react';

const Vue_Emit = () => {
  return (
    <div>
      <h1>Vue_Emit Component</h1>
      <p>This is the Vue_Emit tutorial page.</p>
    </div>
  );
}

export default Vue_Emit;
